import styled from '@emotion/styled';
import { HTMLAttributes } from 'react';

const TooltipWrapper = styled.div`
  white-space: pre-line;
`;

const Term = styled.div<{ isNegative: boolean; isPositive: boolean }>`
  color: ${({ theme, isNegative, isPositive }) =>
    (isPositive && theme.palette.success.main) ||
    (isNegative && theme.palette.error.main) ||
    theme.palette.text.primary};
  font-size: ${({ theme }) => theme.typography.body2.fontSize};
`;

interface TermProps extends HTMLAttributes<HTMLDivElement> {
  term: string;
}

export const TermComponent = (props: TermProps) => {
  const { term, ...rest } = props;
  const trimmed = term.trim();
  const isNegative = trimmed.startsWith('-') || trimmed.startsWith('—');
  const isPositive = trimmed.startsWith('+');
  return (
    <Term isNegative={isNegative} isPositive={isPositive} {...rest}>
      {trimmed}
    </Term>
  );
};

export const FormulaTooltip = ({ description }: { description: string }) => {
  const terms = description.split(/(?=[+\-—])/);
  return (
    <TooltipWrapper>
      {terms.map(term => (
        <TermComponent term={term} key={term} />
      ))}
    </TooltipWrapper>
  );
};
